"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var filters_1 = require("@/filter/filters");
var RatingStarsReader_vue_1 = __importDefault(require("@/components/rating-stars-reader/RatingStarsReader.vue"));
var ImagesGalleryExtended_vue_1 = __importDefault(require("@/components/images-gallery/extended/ImagesGalleryExtended.vue"));
var MapPointOfInterest_vue_1 = __importDefault(require("@/components/maps/map-point-of-interest/MapPointOfInterest.vue"));
var ScheduleViewer_vue_1 = __importDefault(require("@/components/schedule-viewer/ScheduleViewer.vue"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var PointOfInterestExtended = /** @class */ (function (_super) {
    __extends(PointOfInterestExtended, _super);
    function PointOfInterestExtended() {
        var _this = _super.call(this) || this;
        dayjs_1.default.extend(utc_1.default);
        dayjs_1.default.extend(customParseFormat_1.default);
        return _this;
    }
    PointOfInterestExtended.prototype.mounted = function () {
        this.emitEventInteraction();
    };
    PointOfInterestExtended.prototype.emitEventInteraction = function () {
        if (!this.pointOfInterest) {
            return;
        }
        var interaction = {
            type: parameters_1.default.clientTracking.interactionTypes.pointOfInterestViewed,
            locale: this.$i18n.locale,
            partnership_slug: this.$route.params.partnershipSlug,
            client_utc_date: dayjs_1.default.utc().format('YYYY-MM-DD HH:mm:ss'),
            point_of_interest_id: this.pointOfInterest.id
        };
        this.$root.$emit('USER_INTERACTION', interaction);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], PointOfInterestExtended.prototype, "pointOfInterest", void 0);
    PointOfInterestExtended = __decorate([
        vue_property_decorator_1.Component({
            name: 'PointOfInterestExtended',
            components: {
                RatingStarsReader: RatingStarsReader_vue_1.default,
                ImagesGalleryExtended: ImagesGalleryExtended_vue_1.default,
                MapPointOfInterest: MapPointOfInterest_vue_1.default,
                ScheduleViewer: ScheduleViewer_vue_1.default
            },
            filters: {
                translation: filters_1.translation
            }
        })
    ], PointOfInterestExtended);
    return PointOfInterestExtended;
}(vue_1.default));
exports.default = PointOfInterestExtended;
